import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';

export default class WorksiteTask extends BaseModel
{

    static getPrefix()
    {
        return 'worksite:worksite-task';
    }

    static getEndpoint(worksite)
    {
        return window.Worksite.endpoints.worksiteTask.setWorksite(worksite);
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint(this.currentCollection.worksite);
    }
    
    static default(columns, data)
    {
        data = {...{first: false, position: 1, group_id: null}, ...data};

        data.column_values = columns.map(column => {
            return {
                column_id: column.id,
                value: column.getDefaultValue(data.first)
            }
        });

        return new this(data);
    }

    getColumnValueModel(columnId)
    {
        return this.column_values.find(val => val.column_id == columnId);
    }

    getColumnValue(columnId)
    {
        return this.getColumnValueModel(columnId).value;
    }

    setColumnValue(columnId, newValue)
    {
        let model = this.getColumnValueModel(columnId);
        if ( ! model ) {
            this.column_values.push({
                column_id: columnId,
                value: newValue
            });
        } else {
            this.getColumnValueModel(columnId).value = newValue;
        }
    }

    getStatus(columns)
    {
        return this.getColumnValue(
            columns.find(c => c.type === 'status').id
        );
    }

    isCompleted(columns)
    {
        return this.getStatus(columns) == window.App.$t('worksite.tasks.columns.status.values.completed');
    }

};